import { config } from "../config";

enum METHOD {
	GET = "GET",
	POST = "POST",
}

/* eslint-disable @typescript-eslint/no-explicit-any */
type TRequest = <T>(methodName: string, data?: any) => Promise<T>;

const transport = async <T>(
	method: string,
	path: string,
	data: Record<string, unknown>,
): Promise<T> => {
	const url = `${config.api.admin.domain}${path}`;
	const body = data ? JSON.stringify(data) : undefined;

	const response = await fetch(url, {
		method: method,
		body,
	});

	const json = await response.json();

	return json;
};

export const requestAdmin = {
	get: transport.bind(this, METHOD.GET) as TRequest,
	post: transport.bind(this, METHOD.POST) as TRequest,
};
